<!--登陆页首页-->
<template>
  <div class="main">
    <div class="login-menu">
      <user-login v-if="activeName === 'user'"></user-login>
<!--      <a-->
<!--        @click.stop="activeName='user'"-->
<!--        href="#">账号密码</a>-->
<!--      <a-->
<!--        @click.stop="activeName='code'"-->
<!--        href="#">手机号登录</a>-->
<!--      <a-->
<!--        @click.stop="activeName='third'"-->
<!--        href="#">第三方登录</a>-->
    </div>
  </div>
</template>

<script>
import userLogin from './userLogin'

export default {
  name: 'Index',
  components: {
    userLogin
  },
  data () {
    return {
      activeName: 'user'
    }
  }
}
</script>

<style lang="less" scoped>
  .login-menu {
    margin-top: 40px;
    width: 100%;
    text-align: center;

    a {
      color: #999;
      font-size: 12px;
      margin: 0px 8px;
    }
  }

  .login-select {
    width: 100%;
    margin-bottom: 10px;

    input {
      color: #333;
      font-size: 18px;
      font-weight: 400;
      border: none;
      text-align: center;
    }
  }

</style>
